import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  CircularProgress,
  Typography,
} from '@material-ui/core';

import { makeStyles, useTheme } from '@material-ui/core/styles';

import {
  Done as DoneIcon,
  Error as ErrorIcon,
  SkipNext as SkipNextIcon,
  Timer as TimerIcon,
  DeviceUnknown as UnknownIcon,
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
  },
  label: {
  },
}));

const StatusAdornment = (props) => {
  const { value, adornment } = props;
  const adornmentStyle=adornment==='start'? { marginRight: '4px' } : { marginLeft: '4px' };
  if(value==='RUNNING') {
    return(
      <Box position="relative" display="inline-flex" style={adornmentStyle}>
        <CircularProgress size={16} thickness={8}/>
      </Box>    
    );
  } else {
    let AdornmentIcon=UnknownIcon;
    if(value==='PENDING') {
      AdornmentIcon=CrawlPendingIcon;
    } else if(value==='FAILED') {
      AdornmentIcon=CrawlFailedIcon;
    } else if(value==='SUCCEEDED') {
      AdornmentIcon=CrawlSucceededIcon;
    } else if(value==='SKIPPED') {
      AdornmentIcon=CrawlSkippedIcon;
    }
    return(
      <Box position="relative" display="inline-flex" style={adornmentStyle}>
        <AdornmentIcon/>
      </Box>    
    );
  }
};

export function CrawlSucceededIcon(props) {
  const theme = useTheme();
  return (
    <DoneIcon fontSize='small' htmlColor={theme.palette.success.main} {...props}/>
  );
}

export function CrawlPendingIcon(props) {
  const theme = useTheme();
  return (
    <TimerIcon fontSize='small' htmlColor={theme.palette.info.main} {...props}/>
  );
}

export function CrawlSkippedIcon(props) {
  const theme = useTheme();
  return (
    <SkipNextIcon fontSize='small' htmlColor={theme.palette.warning.main} {...props} />
  );
}

export function CrawlFailedIcon(props) {
  const theme = useTheme();
  return (
    <ErrorIcon fontSize='small' htmlColor={theme.palette.error.main} {...props} />
  );
}



export default function CrawlStatus(props) {

  const { value, adornment } = props;
  
  const classes = useStyles();


  if(!value){
    return(null);  
  }

  return(
    <div className={classes.root}>
      {adornment==='start'?<StatusAdornment { ...{value, adornment}}/>:null}
      <Typography variant='body2' className={classes.label}>{value}</Typography>
      {adornment==='end'?<StatusAdornment {...{value, adornment}}/>:null}
    </div>
  );

}

CrawlStatus.propTypes = {
  value: PropTypes.string,
  adornment: PropTypes.oneOf(['none','start','end']).isRequired,
};

CrawlStatus.defaultProps = {
  adornment: 'start'
};

